import { ChangeEvent, FunctionComponent, useCallback } from 'react';

import ExinMuiRadioGroup from '../styled/ExinMuiRadioGroup';
import { Country } from './StepBookingCountry';

export type Center = {
  value: string;
  label: string;
  tooltip: any;
};

const StepBookingCenter: FunctionComponent<{
  center: Center | null;
  country: Country;
  setCenter(center: Center | null): void;
}> = ({ center, country, setCenter }) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setCenter(
        country.services.find(
          (service: Center): boolean => service?.value === event.target.value
        ) || null
      );
    },
    [setCenter, country.services]
  );

  if (!country.services) {
    return <>No centers found</>;
  }

  return (
    <ExinMuiRadioGroup
      value={center?.value || ''}
      onChange={handleChange}
      options={country.services}
    />
  );
};

export default StepBookingCenter;
